module.exports = "/_next/static/images/15045772c53d2b057dc142ed4086d080-pj-man-holding-business-card@3x.jpg.webp";